import { render, staticRenderFns } from "./ChallengesTab.vue?vue&type=template&id=5bca6ee6&scoped=true&"
import script from "./ChallengesTab.vue?vue&type=script&lang=js&"
export * from "./ChallengesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca6ee6",
  null
  
)

export default component.exports